// Shared, cross-feature strings: generic actions, statuses, and words reused
// across many views. Feature-specific copy belongs in that feature's namespace.
export default {
  en: {
    changeLanguage: 'Change language',
    breadcrumbs: 'Breadcrumbs',
    viewCart: 'View cart',
    undo: 'Undo',
    backToTop: 'Back to top',
    loading: 'Loading…',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    retry: 'Retry',
    search: 'Search',
    remove: 'Remove',
    delete: 'Delete',
    edit: 'Edit',
    continue: 'Continue',
    goHome: 'Go to homepage',
    somethingWrong: 'Something went wrong. Please try again.',
    required: 'This field is required.',
    email: 'Email',
    password: 'Password',
    yes: 'Yes',
    no: 'No',
    status: {
      CREATED: 'Created',
      PAID: 'Paid',
      PROCESSING: 'Processing',
      DELIVERED: 'Delivered',
      COMPLETED: 'Completed',
      FAILED: 'Failed',
      REFUNDED: 'Refunded',
    },
  },
  cs: {
    changeLanguage: 'Změnit jazyk',
    breadcrumbs: 'Drobečková navigace',
    viewCart: 'Zobrazit košík',
    undo: 'Vrátit zpět',
    backToTop: 'Zpět nahoru',
    loading: 'Načítání…',
    save: 'Uložit',
    saving: 'Ukládání…',
    cancel: 'Zrušit',
    confirm: 'Potvrdit',
    close: 'Zavřít',
    back: 'Zpět',
    next: 'Další',
    retry: 'Zkusit znovu',
    search: 'Hledat',
    remove: 'Odebrat',
    delete: 'Smazat',
    edit: 'Upravit',
    continue: 'Pokračovat',
    goHome: 'Přejít na úvodní stránku',
    somethingWrong: 'Něco se pokazilo. Zkuste to prosím znovu.',
    required: 'Toto pole je povinné.',
    email: 'E-mail',
    password: 'Heslo',
    yes: 'Ano',
    no: 'Ne',
    status: {
      CREATED: 'Vytvořeno',
      PAID: 'Zaplaceno',
      PROCESSING: 'Zpracovává se',
      DELIVERED: 'Doručeno',
      COMPLETED: 'Dokončeno',
      FAILED: 'Selhalo',
      REFUNDED: 'Vráceno',
    },
  },
};
